import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { Status } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';

export type StatusCellValue = Union.Nullable<string | number>;

interface StatusCellProps<R extends GridValidRowModel = any> {
  value: StatusCellValue;
  row: R;
  statusColor?: string;
  i18nKeyPrefix?: string;
  i18ns?: string;
}

export const StatusCell = <R extends GridValidRowModel = any>({
  value,
  statusColor,
  i18nKeyPrefix,
  i18ns,
}: StatusCellProps<R>) => {
  const { t } = useTranslation(i18ns, { keyPrefix: i18nKeyPrefix });
  return (
    <>{value ? <Status statusColor={statusColor || 'text.primary'}>{t(String(value))}</Status> : NULLISH_CELL_VALUE}</>
  );
};
